/*
 * ${locale}.resources.${resourceName}.name for resource names (used for the menu and page titles)
 * ${ locale }.resources.${ resourceName }.fields.${ fieldName } for field names(used for datagrid header and form input labels)
 */

export default {
    'unauthorised-action': 'This is an unauthorised action',
    actions: {
        add: 'Add',
        amend: 'Amend',
        cancel: 'Cancel',
        close: 'Close',
        create: 'Create',
        configure: 'Configure',
        confirm: 'Confirm',
        deduct: 'Deduct',
        delete: 'Delete',
        duplicate: 'Duplicate',
        edit: 'Edit',
        export: 'Export',
        generated: 'Generated',
        goBack: 'Go Back',
        hide: 'Hide',
        import: 'Import',
        invite: 'Invite',
        list: 'List',
        no: 'No',
        ok: 'Ok',
        pause: 'Pause',
        refresh: 'Refresh',
        refund: 'Refund',
        reset: 'Clear values',
        resume: 'Resume',
        retry: 'Retry',
        returnTo: 'Return to',
        returnToThe: 'Return to the',
        save: 'Save',
        search: 'Search',
        select: 'Select',
        show: 'Show',
        signIn: 'Sign in',
        start: 'Start',
        stop: 'Stop',
        submit: 'Submit',
        submit_add_another: 'Submit and Add another',
        terminate: 'Terminate',
        translate: 'translate',
        yes: 'Yes',
    },
    auth: {
        forgotPassword: {
            actions: {
                iRemember: 'I remember',
                resetPassword: 'Reset password',
            },
            fields: {
                email: 'Email',
            },
            notifications: {
                success: 'If we could find your account, you will receive an email shortly.',
            },
            title: 'Forgot your password?',
        },
        login: {
            fields: {
                email: 'Email',
                password: 'Password',
            },
            notifications: {
                failure: 'Invalid credentials',
            },
            noCookies: {
                description: 'Cookies are not enabled on your browser. Please enable cookies in your browser preferences to continue.',
                title: 'Cookies Required',
            },
        },
        logout: {
            description: 'Are you sure you wish to log out?',
            title: 'Log Out',
            notifications: {
                failure: 'Your account could not be logged out.',
                success: 'Your account has been successfully logged out',
            },
        },
    },
    components: {
        autocomplete: {
            hinttext: 'Type to start searching',
        },
    },
    countries: {
        AD: 'Andorra',
        AE: 'United Arab Emirates',
        AF: 'Afghanistan',
        AG: 'Antigua and Barbuda',
        AI: 'Anguilla',
        AL: 'Albania',
        AM: 'Armenia',
        AO: 'Angola',
        AQ: 'Antarctica',
        AR: 'Argentina',
        AS: 'American Samoa',
        AT: 'Austria',
        AU: 'Australia',
        AW: 'Aruba',
        AX: 'Aland Islands',
        AZ: 'Azerbaijan',
        BA: 'Bosnia and Herzegovina',
        BB: 'Barbados',
        BD: 'Bangladesh',
        BE: 'Belgium',
        BF: 'Burkina Faso',
        BG: 'Bulgaria',
        BH: 'Bahrain',
        BI: 'Burundi',
        BJ: 'Benin',
        BL: 'Saint Barthelemy',
        BM: 'Bermuda',
        BN: 'Brunei',
        BO: 'Bolivia',
        BQ: 'Bonaire, Saint Eustatius and Saba ',
        BR: 'Brazil',
        BS: 'Bahamas',
        BT: 'Bhutan',
        BV: 'Bouvet Island',
        BW: 'Botswana',
        BY: 'Belarus',
        BZ: 'Belize',
        CA: 'Canada',
        CC: 'Cocos Islands',
        CD: 'Democratic Republic of the Congo',
        CF: 'Central African Republic',
        CG: 'Republic of the Congo',
        CH: 'Switzerland',
        CI: 'Ivory Coast',
        CK: 'Cook Islands',
        CL: 'Chile',
        CM: 'Cameroon',
        CN: 'China',
        CO: 'Colombia',
        CR: 'Costa Rica',
        CU: 'Cuba',
        CV: 'Cape Verde',
        CW: 'Curacao',
        CX: 'Christmas Island',
        CY: 'Cyprus',
        CZ: 'Czech Republic',
        DE: 'Germany',
        DJ: 'Djibouti',
        DK: 'Denmark',
        DM: 'Dominica',
        DO: 'Dominican Republic',
        DZ: 'Algeria',
        EC: 'Ecuador',
        EE: 'Estonia',
        EG: 'Egypt',
        EH: 'Western Sahara',
        ER: 'Eritrea',
        ES: 'Spain',
        ET: 'Ethiopia',
        FI: 'Finland',
        FJ: 'Fiji',
        FK: 'Falkland Islands',
        FM: 'Micronesia',
        FO: 'Faroe Islands',
        FR: 'France',
        GA: 'Gabon',
        GB: 'United Kingdom',
        GD: 'Grenada',
        GE: 'Georgia',
        GF: 'French Guiana',
        GG: 'Guernsey',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GL: 'Greenland',
        GM: 'Gambia',
        GN: 'Guinea',
        GP: 'Guadeloupe',
        GQ: 'Equatorial Guinea',
        GR: 'Greece',
        GS: 'South Georgia and the South Sandwich Islands',
        GT: 'Guatemala',
        GU: 'Guam',
        GW: 'Guinea-Bissau',
        GY: 'Guyana',
        HK: 'Hong Kong',
        HM: 'Heard Island and McDonald Islands',
        HN: 'Honduras',
        HR: 'Croatia',
        HT: 'Haiti',
        HU: 'Hungary',
        ID: 'Indonesia',
        IE: 'Ireland',
        IL: 'Israel',
        IM: 'Isle of Man',
        IN: 'India',
        IO: 'British Indian Ocean Territory',
        IQ: 'Iraq',
        IR: 'Iran',
        IS: 'Iceland',
        IT: 'Italy',
        JE: 'Jersey',
        JM: 'Jamaica',
        JO: 'Jordan',
        JP: 'Japan',
        KE: 'Kenya',
        KG: 'Kyrgyzstan',
        KH: 'Cambodia',
        KI: 'Kiribati',
        KM: 'Comoros',
        KN: 'Saint Kitts and Nevis',
        KP: 'North Korea',
        KR: 'South Korea',
        KW: 'Kuwait',
        KY: 'Cayman Islands',
        KZ: 'Kazakhstan',
        LA: 'Laos',
        LB: 'Lebanon',
        LC: 'Saint Lucia',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Liberia',
        LS: 'Lesotho',
        LT: 'Lithuania',
        LU: 'Luxembourg',
        LV: 'Latvia',
        LY: 'Libya',
        MA: 'Morocco',
        MC: 'Monaco',
        MD: 'Moldova',
        ME: 'Montenegro',
        MF: 'Saint Martin',
        MG: 'Madagascar',
        MH: 'Marshall Islands',
        MK: 'Macedonia',
        ML: 'Mali',
        MM: 'Myanmar',
        MN: 'Mongolia',
        MO: 'Macao',
        MP: 'Northern Mariana Islands',
        MQ: 'Martinique',
        MR: 'Mauritania',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauritius',
        MV: 'Maldives',
        MW: 'Malawi',
        MX: 'Mexico',
        MY: 'Malaysia',
        MZ: 'Mozambique',
        NA: 'Namibia',
        NC: 'New Caledonia',
        NE: 'Niger',
        NF: 'Norfolk Island',
        NG: 'Nigeria',
        NI: 'Nicaragua',
        NL: 'Netherlands',
        NO: 'Norway',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'New Zealand',
        OM: 'Oman',
        PA: 'Panama',
        PE: 'Peru',
        PF: 'French Polynesia',
        PG: 'Papua New Guinea',
        PH: 'Philippines',
        PK: 'Pakistan',
        PL: 'Poland',
        PM: 'Saint Pierre and Miquelon',
        PN: 'Pitcairn',
        PR: 'Puerto Rico',
        PS: 'Palestinian Territory',
        PT: 'Portugal',
        PW: 'Palau',
        PY: 'Paraguay',
        QA: 'Qatar',
        RE: 'Reunion',
        RO: 'Romania',
        RS: 'Serbia',
        RU: 'Russia',
        RW: 'Rwanda',
        SA: 'Saudi Arabia',
        SB: 'Solomon Islands',
        SC: 'Seychelles',
        SD: 'Sudan',
        SE: 'Sweden',
        SG: 'Singapore',
        SH: 'Saint Helena',
        SI: 'Slovenia',
        SJ: 'Svalbard and Jan Mayen',
        SK: 'Slovakia',
        SL: 'Sierra Leone',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somalia',
        SR: 'Suriname',
        SS: 'South Sudan',
        ST: 'Sao Tome and Principe',
        SV: 'El Salvador',
        SX: 'Sint Maarten',
        SY: 'Syria',
        SZ: 'Swaziland',
        TC: 'Turks and Caicos Islands',
        TD: 'Chad',
        TF: 'French Southern Territories',
        TG: 'Togo',
        TH: 'Thailand',
        TJ: 'Tajikistan',
        TK: 'Tokelau',
        TL: 'East Timor',
        TM: 'Turkmenistan',
        TN: 'Tunisia',
        TO: 'Tonga',
        TR: 'Turkey',
        TT: 'Trinidad and Tobago',
        TV: 'Tuvalu',
        TW: 'Taiwan',
        TZ: 'Tanzania',
        UA: 'Ukraine',
        UG: 'Uganda',
        UM: 'United States Minor Outlying Islands',
        US: 'United States',
        UY: 'Uruguay',
        UZ: 'Uzbekistan',
        VA: 'Vatican',
        VC: 'Saint Vincent and the Grenadines',
        VE: 'Venezuela',
        VG: 'British Virgin Islands',
        VI: 'U.S. Virgin Islands',
        VN: 'Vietnam',
        VU: 'Vanuatu',
        WF: 'Wallis and Futuna',
        WS: 'Samoa',
        XK: 'Kosovo',
        YE: 'Yemen',
        YT: 'Mayotte',
        ZA: 'South Africa',
        ZM: 'Zambia',
        ZW: 'Zimbabwe',
    },
    elements: {
        confirm: {
            description: 'You will not be able to edit the subscription products after this action.',
            title: 'Are you sure you wish to confirm this subcription?',
        },
        delete: {
            description: 'The item will be removed permanently. This action cannot be undone.',
            title: 'Are you sure you wish to delete this?',
        },
        outdatedBrowser: {
            description: 'Our Dashboard tool does not support the current version of your browser. For a better experience using this website please update your browser to the latest version.',
            linkText: 'Click here to find out how',
            title: 'Improve your Dashboard experience!',
        },
        terminate: {
            description: 'The subscription will be terminated permanently.',
            title: 'Are you sure you wish to terminate this subcription?',
        },
    },
    export: {
        error: {
            maximum_reached: 'But our exports cannot contain more than 15.000 bookings. You can add more filters to decrease the number of bookings or continue and export the first 15.000 results.',
            title: 'We knew you are successful...',
        },
        description: 'Select which fields you’d like to see in your export',
        notifications: {
            empty_filters: {
                description: 'This requires one or more applied filters. Please apply one or more filters to make an export.',
                title: 'We’re missing filters',
            },
        },
        title: 'Preparing export',
        field_groups: {
            booking: 'Booking',
            consumer: 'Consumer',
            customer: 'Customer',
            default: 'Default',
            financial: 'Financial',
            payment_method: 'Payment method',
            product: 'Product',
            user_attributes: 'User attributes',
        },
        fields: {
            administration_fee: 'Administration fee',
            amount: 'Amount',
            arrival_date: 'Arrival date',
            booking_date: 'Booking_date',
            costfree_cancellation: 'Cancellation insurance',
            currency: 'Currency',
            customer_email: 'Customer email',
            customer_first_name: 'Customer first name',
            customer_last_name: 'Customer last name',
            customer_license_plate: 'Customer license plate',
            customer_phone: 'Customer phone',
            customer_remarks: 'Customer remarks',
            departure_date: 'Departure date',
            discount_amount: 'Discount amount',
            discount_company_name: 'Discount company name',
            discount_owner_id: 'Discount owner ID',
            discount_title: 'Discount name',
            email: 'Email',
            first_name: 'First name',
            gateway: 'Gateway',
            has_failed_invoice: 'Has failed invoice',
            id: 'ID',
            internal_order_id: 'Order ID',
            invoiced_at: 'Invoiced at',
            last_name: 'Last name',
            locale: 'Locale',
            method: 'Method',
            number_of_persons: 'Number of persons',
            options_price: 'Options price',
            order_id: 'Order id',
            payment_amount_paid: 'Payment amount paid',
            payment_status: 'Payment status',
            payment_method: 'Payment method',
            payment_method_status: 'Payment method status',
            price_membership_deduction: 'Membership deduction',
            phone: 'Phone',
            price: 'Price',
            product_address: 'Product address',
            product_id: 'Product ID',
            product: 'Product',
            provider_id: 'Provider ID',
            provider_price_total: 'Provider price total',
            provider_price: 'Provider price',
            provider: 'Provider',
            reseller_funnel: 'Reseller funnel',
            reseller_id: 'Reseller ID',
            reseller_price_total: 'Reseller price total',
            reseller_price: 'Reseller price',
            reseller: 'Reseller',
            reservation_status: 'Reservation status',
            return_flight_number: 'Return flight number',
            status: 'Status',
            transaction_fee: 'Transaction fee',
            yield_price: 'Yield price',
        },
    },
    fields: {
        currency: 'Currency',
        datetime: {
            never: 'Never',
        },
        full: 'Full',
        empty: 'Unknown',
        none: 'None',
        optional: '(Optional)',
        other: 'Other',
        percentage: 'Percentage',
        price: 'Price',
        price_original: 'Original price',
        reason: 'Reason',
        dates: 'Dates',
        is_scheduled: 'Scheduled',
        ends_at: 'Ends at',
        size: 'Size',
        starts_at: 'Starts at',
        updated: 'Updated',
        weekday: {
            1: 'Monday',
            2: 'Tuesday',
            3: 'Wednesday',
            4: 'Thursday',
            5: 'Friday',
            6: 'Saturday',
            7: 'Sunday',
        },
    },
    forms: {
        email: 'Must be an email',
        error: {
            'location-not-found': 'The location could not be found',
            'location-could-not-be-resolved': 'The location could not be found',
            'the-id-format-is-invalid': 'The id format is invalid',
        },
        invalid: {
            discount_rule: 'Invalid discount rule',
            email: 'Invalid email',
            first_name: 'Invalid firstname',
            general: 'Invalid characters',
            last_name: 'Invalid lastname',
            match: 'The value with %{field} does not match',
            max_characters: 'Must be %{max} characters or less',
            phone: 'This is an invalid phone number',
            url: 'This is an invalid URL',
        },
        localisation: {
            available: {
                title: 'Add a language',
            },
            origin: {
                description: 'Do you want to translate the current texts from %{locale} to %{target}?',
                title: 'Translate from %{source}',
            },
            update: {
                description: 'Do you want to translate the current texts from %{locale} to %{target}?',
                description_2: 'The translation will overwrite the current %{target} texts.',
                description_3: 'They are not saved until you submit the form.',
                inactive: 'Please add the text in %{locale} before you can translate to this language.',
                title: 'Translate to english',
            },
            required: {
                description: 'It is required to enter all English texts before you can add other languages.',
                title: 'Add a language',
            },
        },
        no_results: 'There are no descriptions added to this product.',
        number: 'Must be a number',
        one_of_them_required: 'Please fill one of these fields.',
        required: 'The value is required',
        submit: {
            required: '%{locale} - %{key} is required',
        },
    },
    filters: {
        add: 'Add a filter',
        category: {
            advanced: 'advanced',
            basic: 'basic',
        },
        clear_all_filters: 'Clear all filters',
        components: {
            accountId: {
                label: 'Account',
            },
            booking: {
                label: 'Booking',
            },
            bookingOrderId: {
                label: 'Booking Order Id',
            },
            bookingReservationOrderId: {
                label: 'Reservation order id',
            },
            cancelled: {
                label: 'Cancelled',
            },
            cancelledAt: {
                label: 'Cancelled at',
                placeholder: 'Choose a date',
            },
            categoryId: {
                label: 'Category',
                placeholder: 'Choose a category',
            },
            companyName: {
                label: 'Company name',
            },
            createdAt: {
                label: 'Created at',
                placeholder: 'Choose a date',
            },
            currencies: {
                label: 'Currencies',
                placeholder: 'Choose a currency',
            },
            destinationArrivalDate: {
                label: 'Arrival date',
                placeholder: 'Start (destination arrival)',
            },
            destinationDepartureDate: {
                label: 'Departure date',
                placeholder: 'End (destination departure)',
            },
            email: {
                label: 'Email',
            },
            end_date_null_or_from: {
                label: 'End date from',
            },
            enabled: {
                choices: {
                    active: 'Only active',
                    inactive: 'Only inactive',
                },
                label: 'Enabled',
            },
            funnelId: {
                label: 'Campaigns',
            },
            interval: {
                choices: {
                    day: 'Day',
                    month: 'Month',
                    week: 'Week',
                    year: 'Year',
                },
                label: 'Interval',
            },
            is_rebooked: {
                choices: {
                    active: 'Only rebooked',
                    inactive: 'Only not rebooked',
                },
                label: 'Rebooked',
            },
            is_terminated: {
                label: 'Terminated',
            },
            invoice: {
                label: 'Invoice',
            },
            lastName: {
                label: 'Last name',
            },
            licensePlate: {
                label: 'License plate',
            },
            name: {
                label: 'Name',
            },
            orderId: {
                label: 'Order Id',
            },
            paymentStatus: {
                choices: {
                    chargedback: 'Charged back',
                    deferred: 'Deferred',
                    failed: 'Failed',
                    inProgress: 'In progress',
                    refunded: 'Refunded',
                    success: 'Success',
                    unknown: 'Unknown',
                },
                label: 'Payment status',
                placeholder: 'Select your payment',
            },
            phone: {
                label: 'Phone number',
            },
            pointOfInterestId: {
                label: 'Point of Interest',
            },
            productId: {
                label: 'Product',
            },
            providerId: {
                label: 'Provider',
            },
            resellerId: {
                label: 'Reseller',
            },
            reservationStatus: {
                choices: {
                    awaiting: 'Awaiting',
                    canceled: 'Canceled',
                    completed: 'Completed',
                    error: 'Error',
                    pending: 'Pending',
                    split: 'Split',
                    underReview: 'Under Review',
                },
                label: 'Reservation status',
            },
            subcategoryId: {
                label: 'Subcategory',
                placeholder: 'Subcategory',
            },
            status: {
                label: 'Status',
            },
            testBooking: {
                choices: {
                    real: 'Only Real',
                    test: 'Only Test',
                },
                label: 'Booking type',
            },
            userId: {
                label: 'User',
            },
            product_membership_id: {
                label: 'Product membership',
            },
            user_product_membership_pool_id: {
                label: 'Membership pool',
            },
            usesDiscountCodes: {
                choices: {
                    active: 'Use discount codes',
                    inactive: 'No discount codes',
                },
                label: 'Uses discount codes',
            },
        },
        title: 'Filters',
        matchtype: 'Match type',
        matchtypes: {
            between: 'Between',
            contains: 'Contains',
            ends_with: 'Ends with',
            equals: 'Equals',
            match_all_of: 'Match all of',
            match_one_of: 'Match one of',
            near: 'Near',
            range: 'Within',
            starts_with: 'Starts with',
        },
    },
    general: {
        data_updated: 'Data updated',
        error: 'Something went wrong, please try again later...',
        images: 'Images',
        loading: 'Loading...',
        noMatches: 'Couldn’t find any matches',
    },
    impersonation: {
        actions: {
            log_in: 'Impersonate',
            log_out: 'Back to your account',
        },
        logged_in: 'You are currently logged in as %{name}',
    },
    languages: {
        dutch: 'Dutch',
        english: 'English',
        german: 'German',
        french: 'French',
        italian: 'Italian',
        spanish: 'Spanish',
    },
    localisations: {
        dialog: {
            label: 'Select an available language',
        },
    },
    dropzone: {
        label: {
            button: 'Upload logo',
            button_image: 'Upload image',
            description_file_max: 'Max. file-size: %{max} KB',
            description_max: 'Max. height: %{height}px, Max. width: %{width}px',
            description_min: 'Min. height: %{height}px, Min. width: %{width}px',
            format: 'Format: %{format}',
            highlight_image: 'Highlight image',
            highlighted_image: 'Highlighted image',
            remove_highlight: 'Remove highlight',
            text: 'Click or drag',
        },
    },
    menu: {
        sidebar: {
            assets: 'Assets',
            access_points: 'Access points',
            accounts: 'Accounts',
            account_administration: 'Account administration',
            account_details: 'Account details',
            account_yields: 'Yielding',
            all_accounts: 'All Accounts',
            all_users: 'All Users',
            'api-keys': 'API keys',
            bookingStats: 'Statistics',
            bookings: 'Bookings',
            campaigns: 'Campaigns',
            content: 'Content',
            dashboard: 'Dashboard',
            discounts: 'Discounts',
            internal_yield_service_user: 'Yields',
            invoices: 'Invoices',
            legaldocuments: {
                engagement_agreement: 'Engagement agreement',
                main: 'Legal documents',
                privacy_statement: 'Privacy statement',
                terms_conditions: 'Terms & conditions',
            },
            memberships: 'Memberships',
            membership_schedules: 'Membership Schedules',
            membership_pools: 'Membership Pools',
            order_create: 'Create a Booking',
            order_create_disallowed: 'Your account is inactive, to reactivate contact MOBIAN.',
            points_of_interest: 'Points of interest',
            products: 'Products',
            product_memberships: 'Product memberships',
            properties: 'Properties',
            propertygroups: 'Property groups',
            reservations: 'Reservations',
            settings: 'Settings',
            subcategories: 'Subcategories',
            subscriptions: 'Subscriptions',
            system_administration: 'System administration',
            users: 'Users',
            webhooks: 'Webhooks',
        },
        topbar: {
            accounts: {
                current: 'Current',
                modal_title: 'Select an account',
                no_account_selected: 'No account selected',
            },
            security: 'Security',
            profile: 'Profile',
            stop_impersonation: 'Stop impersonation',
        },
    },
    notifications: {
        access_methods: {
            create: {
                success: 'The access method has been successfully added',
            },
            delete: {
                success: 'The access method has been successfully removed',
            },
            open: {
                success: 'The gate has been opened',
            },
            update: {
                success: 'The access method has been successfully changed',
            },
        },
        accounts: {
            create: {
                success: 'The account has been successfully added',
                search_user_limit: 'Only the first %{count} results are shown, please further refine your search criteria',
            },
            update: {
                success: 'The account has successfully changed',
            },
        },
        account_yields: {
            create: {
                success: 'The User Yield has been successfully added',
            },
            delete: {
                success: 'The User Yield has been successfully removed',
            },
            update: {
                success: 'The User Yield has successfully changed',
            },
        },
        'api-keys': {
            create: {
                success: 'The API key has been successfully added',
            },
            delete: {
                success: 'The API key has been successfully removed',
            },
            update: {
                success: 'The API key has been successfully changed',
            },
        },
        bookings: {
            amend: {
                failure: 'The booking has not been amended',
                success: 'The booking has been succesfully amended',
            },
            refund: {
                failure: 'The refund was not successful',
                success: 'The refund was successful',
            },
        },
        booking: {
            cancelled: 'The booking was successfully cancelled',
        },
        export: {
            failure: 'The export couldn’t be send',
            orders: {
                failure: 'The export couldn’t be send',
                success: 'The export is sent when ready',
            },
            success: 'The export is sent when ready',
        },
        campaigns: {
            create: {
                success: 'The campaign has been added',
            },
            update: {
                success: 'The campaign has been changed',
            },
            remove: {
                success: 'The campaign has been removed',
            },
        },
        current_account: {
            delete: {
                success: 'The user has been removed from this account',
            },
        },
        discount_codes: {
            create: {
                success: 'The discount code has been successfully added',
            },
            delete: {
                success: 'The discount code has been successfully removed',
            },
            update: {
                success: 'The discount code has successfully changed',
            },
        },
        discounts: {
            create: {
                success: 'The discount has been successfully added',
            },
            delete: {
                success: 'The discount has been successfully removed',
            },
            update: {
                success: 'The discount has successfully changed',
            },
        },
        invitations: {
            created: 'The invitation has been successfully added',
            deleted: 'The invitation has been successfully removed',
            accepted: 'The invitation has been accepted',
            denied: 'The invitation has been denied',
        },
        item: {
            created: 'The item is successfully added',
            updated: 'The product has been changed correctly',
        },
        memberships: {
            added: 'User was added to membership successfully',
            delete: {
                success: 'User has been removed from the membership successfully',
            },
        },
        orders: {
            cancelled: {
                success: 'Order cancelled',
            },
            retry: {
                success: 'The booking has been rebooked',
            },
            suspicious: 'Suspicious activity on this booking',
            update: {
                success: 'The booking has successfully changed',
            },
        },
        points_of_interest: {
            create: {
                success: 'The POI has been successfully added',
            },
            delete: {
                success: 'The POI has been successfully removed',
            },
            images: {
                create: {
                    success: 'The image is successfully added',
                },
                delete: {
                    success: 'The image is successfully removed',
                },
            },
            import: {
                success: 'The POI’s have been sucessfully added',
            },
            update: {
                success: 'The POI has successfully changed',
            },
        },
        products: {
            configuration: {
                administration_fee: {
                    maximum: 'Maximum',
                    maximum_placeholder: 'e.g. 1.99, 2.50',
                    minimum: 'Minimum',
                    minimum_placeholder: 'e.g. 1.99, 2.50',
                    percentage: 'Percentage',
                    percentage_placeholder: 'e.g. 0.10 (10%), 0.03 (3%)',
                },
                allow_exceed_capacity_from: 'Invalid allowed exceeded capacity',
                allow_overstay: 'Invalid allowed overstay',
                arrival_dates_blocked: 'Invalid blocked arrival dates',
                blocked_dates: 'Invalid blocked dates',
                capacity: 'Invalid capacity',
                departure_dates_blocked: 'Invalid blocked departure dates',
                freeze_period: 'Invalid freeze period',
                leeway_arrival: 'Invalid arrival time leeway',
                leeway_departure: 'Invalid departure time leeway',
                maximum_advance: 'Invalid maximum advanced time',
                maximum_duration: 'Invalid minimum advanced time',
                minimum_advance: 'Invalid minimum advanced time',
                minimum_duration: 'Invalid duration',
                number_of_persons: 'Invalid number of persons',
                operational_times: 'Invalid operational time(s) specific or non-specific weekdays allowed',
                sales_price: 'Invalid sales price',
                split_percentage: 'Invalid Split Price percentage',
                terms_and_conditions: {
                    name: 'Invalid name',
                    link: 'Invalid url',
                },
                vat_percentage: 'Invalid VAT percentage',
                voucher_include_invoice: 'Invalid voucher include invoice',
            },
            create: {
                success: 'The product has been successfully added',
            },
            delete: {
                success: 'The product has been successfully removed',
            },
            update: {
                success: 'The product has successfully changed',
            },
            failure: 'Product not removed.',
            images: {
                create: {
                    success: 'The image was successfully added',
                },
                delete: {
                    success: 'The image was successfully removed',
                },
            },
            localisation: {
                update: {
                    success: 'The texts have been changed successfully',
                },
            },
            logo: {
                create: {
                    failure: 'Something went wrong while uploading the logo',
                    success: 'The logo is uploaded',
                },
                delete: {
                    success: 'The logo is removed',
                    failure: 'Something went wrong while deleting the logo',
                },
            },
            property: {
                create: {
                    success: 'The property is successfully added',
                },
                delete: {
                    success: 'The property is successfully removed',
                },
                update: {
                    success: 'The property is successfully changed',
                },
            },
            related: {
                create: {
                    success: 'The product has been assigned',
                },
                delete: {
                    success: 'The relation between the products is removed',
                },
            },
            resource: {
                available_resources: {
                    failure: 'Something went wrong while fetching the available resources',
                },
                update: {
                    success: 'The product resource has been successfully changed',
                },
            },
        },
        profile: {
            update: {
                success: 'The profile is successfully changed',
            },
        },
        propertygroups: {
            create: {
                success: 'The property group is successfully added',
            },
            delete: {
                success: 'The property group is successfully removed',
            },
            update: {
                success: 'The property group is successfully changed',
            },
        },
        properties: {
            create: {
                success: 'The properties are successfully added',
            },
            delete: {
                success: 'The properties are successfully removed',
            },
            update: {
                success: 'The properties are successfully changed',
            },
        },
        subcategories: {
            create: {
                success: 'The subcategory is successfully added',
            },
            delete: {
                success: 'The subcategory is successfully removed',
            },
            update: {
                success: 'The subcategory is successfully changed',
            },
        },
        subscriptions: {
            create: {
                success: 'The subscription has been successfully added',
            },
            delete: {
                success: 'The subscription has been successfully removed',
            },
            update: {
                success: 'The subscription has successfully changed',
            },
            confirm: {
                success: 'The subscription has been successfully confirmed',
            },
            terminate: {
                success: 'The subscription has been successfully terminated',
            },
        },
        subscriptionProducts: {
            create: {
                success: 'The subscription product has been successfully added',
            },
            delete: {
                success: 'The subscription product has been successfully removed',
            },
        },
        users: {
            create: {
                success: 'The user has been successfully added',
            },
            delete: {
                success: 'The user has been successfully removed',
            },
            update: {
                success: 'The user has successfully changed',
            },
            confirmed: {
                success: 'The user has been successfully confirmed',
            },
            password: {
                failure: 'Something went wrong while sending the request. Try again later.',
                success: 'The user will be informed by email with a reset password request.',
            },
        },
        user_product_membership: {
            create: {
                success: 'The user product membership has been successfully added',
            },
            delete: {
                success: 'The user product membership has been successfully removed',
            },
            update: {
                success: 'The user product membership has successfully changed',
            },
        },
        utilities: {
            translate: {
                create: {
                    success: 'The text has been translated.',
                },
            },
        },
        yields: {
            delete: {
                success: 'The yield is successfully removed',
            },
        },
        webhooks: {
            create: {
                success: 'The webhook has been successfully added',
            },
            delete: {
                success: 'The webhook has been successfully removed',
            },
            update: {
                success: 'The webhook has been successfully changed',
            },
        },
    },
    pages: {
        booking_tool: {
            not_available: {
                text: 'It looks like no booking comparison tool is available for this account. For more information, please contact your accountmanager.',
                title: 'Oh no... :(',
            },
        },
        create_booking: {
            description: 'Before you can see the products, we ask you to fill in these fields, to make the search more specific.',
            form: {
                errors: {
                    destination_arrival_date: 'Please fill in a date',
                    destination_arrival_time: 'Please fill in a time',
                    destination_departure_date: 'Please fill in a date',
                    destination_departure_time: 'Please fill in a time',
                    destination_google_place_id: 'Please fill in a destination',
                    number_of_persons: 'Please fill the amount of persons',
                    one_way: 'Please fill in the trip type',
                    origin_google_place_id: 'Please fill in the address to be picked up',
                },
                fields: {
                    destination_arrival_date: 'When do you want to leave?',
                    destination_arrival_time: 'Departure time',
                    destination_departure_date: 'When do you want to come back?',
                    destination_departure_time: 'Return time',
                    destination_google_place_id: 'What is your destination?',
                    one_way: {
                        retour_trip: 'Retour Trip',
                        single_trip: 'Single Trip',
                    },
                    origin_google_place_id: 'My Addresss',
                    service: {
                        park_and_sleep: 'Park and Sleep',
                        park_and_walk: 'Park and Walk',
                        public_transport: 'Public Transport',
                        short_long_parking: 'Short/Long Term Parking',
                        taxi: 'Taxi',
                        title: 'Service Options',
                        valet_parking: 'Valet Parking',
                    },
                },
            },
            not_available: {
                text: 'It looks like no Dashboard Funnel is available for this account. For more information, please contact your accountmanager.',
                title: 'Oh no... :(',
            },
            title: 'Create a booking',
        },
        dashboard: {
            select: 'Select your currency',
            widgets: {
                statistics_graph: {
                    current_month: 'last 4 weeks',
                    previous_year: 'last year',
                },
                statistics_card: {
                    current_week: 'This Week',
                    last_week: 'Last Week',
                    today: 'Today',
                    week: 'Week',
                    yesterday: 'Yesterday',
                },
            },
        },
    },
    resources: {
        access_methods: {
            create: {
                title: 'Create an access method',
            },
            delete: {
                title: 'Delete Access method',
                description: 'Are you sure you want to delete this access method?',
            },
            edit: {
                title: 'Edit this access method',
            },
            fields: {
                access_id: 'Access ID',
                access_point_access_method_id: 'Access point access method ID',
                access_point_id: 'Access point ID',
                carpark_id: 'Carpark ID',
                connector_id: 'Connector ID',
                custom_counter_id: 'Custom counter ID',
                depot_id: 'Depot ID',
                direction: 'Direction',
                door_id: 'Door ID',
                enabled: 'Status',
                gate_id: 'Gate ID',
                is_allowed_for_users: 'Allow for users',
                location_id: 'Location ID',
                name: 'Name',
                phone: 'Phone number',
                phone_country: 'Phone country',
                product_id: 'Product ID',
                station_id: 'Station ID',
                subscription_id: 'Subscription ID',
            },
            list: {
                active: 'Active',
                direction: 'Direction',
                directions: {
                    1: 'Enter / Exit',
                    2: 'Enter',
                    3: 'Exit',
                },
                enabled: 'Status',
                inactive: 'Inactive',
            },
            no_results: 'No Access methods found',
            open: 'Open gate',
            requesting: 'Requesting',
            title: 'Access Methods',
        },
        access_points: {
            actions: {
                create: {
                    title: 'Create an access-point',
                },
                edit: {
                    title: 'Edit access-point: %{title}',
                },
            },
            fields: {
                access_point: 'Choose an access point',
                access_method: 'Choose an access method',
                product: 'Product',
                title: 'Title',
                type: 'Type',
            },
            no_results: 'No access points found',
            title: 'Access points',
            types: {
                access: 'Access',
                on_site: 'On site',
            },
        },
        account_yields: {
            actions: {
                create: 'Create a user yield',
                edit: 'Update user yield',
            },
            fields: {
                accountId: 'Account',
                yield: 'Yield',
            },
            title: 'Yields',
        },
        'api-keys': {
            actions: {
                create: 'Create an API key',
                edit: 'Edit API key',
            },
            error: {
                description: 'The maxmium amount of available API Keys has been reached. You can not create any more API Keys. Please remove one before creating a new one.',
                title: 'Whoops...',
            },
            fields: {
                created_at: 'Date',
                last_used_at: 'Last Used',
                name: 'Name',
                token: 'Key',
            },
            modal: {
                description: 'Here is your new API key. <strong>This is the only time the token will be displayed, so be sure not to lose it!</strong> You may delete the token at any time.',
                title: 'API key for %{name}',
            },
            title: 'API Keys',
        },
        accounts: {
            actions: {
                activate: 'Activate',
                create: 'Create account',
                deactivate: 'Deactivate',
                edit: 'Edit account',
            },
            activity: {
                activate: {
                    title: 'The account will be activated',
                    description: 'When the account is active, the account can log in to our dashboards, apps and use our services.',
                },
                deactivate: {
                    title: 'The account will be deactivated',
                    description: 'When the account is inactive, the account can no longer log in to our dashboards, apps or use our services.',
                },
            },
            fields: {
                address: 'Address',
                bic: 'BIC',
                city: 'City',
                contact_details: 'Contact details',
                contact_email: 'Email',
                contact_emergency_phone: 'Emergency phone',
                contact_phone: 'Contact phone',
                contact_whatsapp: 'Whatsapp number',
                country: 'Country',
                email: 'Email',
                iban: 'IBAN',
                is_enabled: 'Enabled',
                last_name: 'Last name',
                locale: 'Locale',
                name: 'Name',
                notify_on_cancelled: 'Notify on cancelled',
                notify_on_created: 'Notify on created',
                notify_on_modified: 'Notify on modified',
                orders: 'Orders',
                owner: 'Owner',
                phone: 'Phone',
                registration: 'Registration',
                role: 'Role',
                vat: 'VAT',
                zipcode: 'Zipcode',
            },
            filters: {
                active: {
                    active: 'Only active',
                    inactive: 'Only inactive',
                },
            },
            forms: {
                account: 'Account',
                account_search_user: 'Search user',
                account_select_user: 'Select user',
                address: 'Address',
                company: 'Company',
                contact: 'Contact',
                general: 'General',
                notifications: 'Email notification preferences',
                products: 'Last Updated Products',
                registrations: 'Registrations',
            },
            name: 'Account',
            products: {
                actions: {
                    list: 'Show all Products (%{total})',
                },
            },
            roles: {
                administrator: 'Administrator',
                provider: 'Provider',
                reseller: 'Reseller',
                support: 'Support',
            },
            select_user: {
                table: {
                    email: 'Email',
                    name: 'Name',
                },
            },
            title: 'Accounts',
        },
        bookings: {
            actions: {
                edit: 'Booking: %{name} (%{id})',
            },
            amend: {
                buttons: {
                    paymentInvoice: 'Pay via invoice',
                    paymentMethod: 'Select Payment method',
                    price: 'Fetch new Price',
                },
                loading: {
                    form: 'Fetching new prices',
                    'price-check-error': 'Something went wrong while checking for a new price',
                    'payment-invoice': 'Attempting payment via invoice',
                    'payment-link': 'Creating payment link',
                    'payment-not-required': 'Amending the updated values',
                    'payment-required': 'Fetching all payment methods',
                    payments: 'Fetching all payment methods',
                    transactions: 'Creating a transaction',
                },
                messages: {
                    'amendError': 'Something went wrong while saving the form.',
                    'payment-invoice': 'Payment is invoiceable. You can save the form.',
                    'payment-not-required': 'Payment is not required. You can save the form.',
                    'payment-required': 'The price difference does not include potential transaction costs.',
                    'price-check-error': 'Something went wrong while checking for a new price',
                    availability: 'This product is no longer available.',
                    linkCopied: 'The Payment link is copied',
                },
                prices: {
                    current: 'Current Price',
                    difference: 'Difference',
                    new: 'New Price',
                },
                phase: {
                    paymentLink: 'Your Payment link for %{title} - %{method}',
                },
                title: 'Amend the booking',
            },
            fields: {
                email: 'Email',
                licensePlate: 'License plate',
                firstName: 'Firstname',
                lastName: 'Lastname',
                phone: 'Phone',
                locale: 'Locale',
                customerRemarks: 'Customer remarks',
                createdAt: 'Created at',
                destinationArrivalDate: 'Arrival date',
                destinationDepartureDate: 'Departure date',
                fullName: 'Fullname',
                funnelId: 'Campaign',
                orderId: 'Booking ID',
                price: 'Price',
                product: 'Product',
                resellerId: 'Reseller',
                status: 'Status',
            },
            forms: {
                additional: 'Additional',
                general: 'General',
            },
            refund: 'Booking refund',
            title: 'Bookings',
        },
        campaigns: {
            actions: {
                create: 'Create a campaign',
                edit: 'Update campaign: %{title}',
            },
            fields: {
                accountId: 'Reseller',
                id: 'ID',
                identifier: 'Identifier',
                name: 'Name',
            },
            name: 'Campaign',
            title: 'Campaigns',
            show: {
                api: 'API',
                catalogue: 'Catalogue',
                week: 'Week',
                last_week: 'Bookings over the last weeks',
                week_number: 'Week #',
                bookings_amount: '# of bookings',
                tabs_title: 'Information regarding catalogue/API usage',
                catalogue_p1: 'Not ready for a full API integration but you want to start fast and secure? MOBIAN’s booking funnel can easily be used and works immediately after creating a campaign. The only thing we need you to send along in your link is your campaign identifier. Your identifier is a unique token which makes it easy for us to add the booking into your account as if you sold it via your own website. We’ve added an example below:',
                catalogue_p2: 'You can add the campaign identifier to any page the booking funnel has to offer. That way you can always let your user start anywhere in the funnel and tailor the experience to their needs.',
                catalogue_p3: 'As soon as a user lands on the page your campaign is attached to, they receive a marker. This marker makes sure that every sale this person makes while having it will be under your account. Be aware; in case a user visits the booking funnel with a new campaign, this will override the current active marker. The markers have a cooldown of 72 hours after which it will be deactivated. Bookings made after that period will not be attached to your account until they visit a link with your identifier once again.',
                api_p1: 'Nice! You’re integrating with the API but you want to define different campaigns or funnels through which you’re selling. You can easily attach a booking to the campaign. For this you might need your technical staff to adjust something in the requests you send to our API. When creating a booking you’re communicating a lot of information already and we’re adding another piece to the puzzle. In the documentation you’ll find a parameter called funnel_id. For this piece info you need to have an ID which you can enter.',
                api_p2: 'The identifier for this campaign is:',
                api_p3: 'After bookings are created with this ID, they will be attached to this campaign automatically.',
            },
        },
        bookingStats: {
            fields: {
                AUD: 'AUD',
                CHF: 'CHF',
                EUR: 'EUR',
                GBP: 'GBP',
                NZD: 'NZD',
                SEK: 'SEK',
                USD: 'USD',
                amount: 'Amount',
                bookings: 'Bookings',
                label: 'Date',
                total: 'Total',
            },
            name: 'Statistics',
            title: 'Booking Statistics',
        },
        orders: {
            actions: {
                check_new_price: 'Check the new price',
                csv: 'CSV',
                export: 'Export bookings',
                export_related: 'Export booking reservations',
                order_email_resent: 'Order email resent',
                resend_email: 'Resend Email',
                retry: 'Retry',
            },
            cancel: {
                description: 'Are you sure you wish to cancel this booking?',
                title: 'Cancel Booking',
            },
            edit: {
                no_longer_editable: 'This information can’t be edited in the system anymore, please contact the provider directly.',
            },
            fields: {
                campaigns: 'Campaigns',
                cancelled_at: 'Cancelled at',
                commission: {
                    int_yield_price: 'Reseller service yield',
                    mobian_commission_total: 'Total',
                    mobian_product_commission_price: 'MOBIAN commission',
                    mobian_product_yield_commission_price: 'Product yield commission',
                    mobian_vat_amount: 'Commission VAT',
                    mobian_vat_price: 'Total',
                    price_administration_fee: 'Administration Costs',
                    price_base: 'Base price',
                    price_costfree_cancellation: 'Cost Free Cancellation',
                    price_options: 'Options',
                    provider_total_price: 'Subtotal',
                    reseller_commission_total: 'Reseller commission',
                    reseller_product_commission_price: 'Product commission',
                    reseller_product_price: 'Booking total',
                    reseller_product_yield_commission_price: 'Yield commission',
                    reseller_vat_amount: 'VAT',
                    reseller_vat_price: 'Total',
                },
                country_code: 'Country code',
                created_at: 'Created',
                customer_remarks: 'Customer Remarks',
                destination_arrival_date: {
                    hours: 'hours',
                    label: 'Arrival Date',
                    minutes: 'minutes',
                },
                destination_address: 'Drop-off location',
                destination_departure_date: {
                    hours: 'hours',
                    label: 'Departure Date',
                    minutes: 'minutes',
                },
                drop_off_date: 'Drop-Off Date',
                ending_at: 'Ending at',
                email: 'Email',
                first_name: 'Firstname',
                flight_number: 'Flight number',
                full_name: 'Name',
                is_test: 'Test',
                last_name: 'lastname',
                license_plate: 'License plate',
                locale: 'Language',
                location_address: 'Location',
                number_of_persons: 'Number of persons',
                order_id: 'Booking',
                origin_address: 'Pick-up location',
                payment_amount_paid: 'Amount paid',
                payment_status: 'Payment status',
                phone: 'Phone',
                pick_up_date: 'Pick-up date',
                price: 'Price',
                product: 'Product',
                provider: 'Provider',
                reservation_status: 'Reservation status',
                return_flight_number: 'Return flight number',
                starting_at: 'Starting at',
                status: 'Status',
                updated_at: 'Last updated',
            },
            filters: {
                cancelled_at: {
                    label: 'Cancelled at',
                    placeholder: 'Cancelled at',
                },
                created_at: {
                    label: 'Created at',
                    placeholder: 'Created at',
                },
                currencies: {
                    label: 'Currencies',
                },
                destination_address: {
                    label: 'Drop-off location',
                },
                destination_arrival_date: {
                    label: 'Arrival date',
                    placeholder: 'Start (destination arrival)',
                },
                destination_departure_date: {
                    label: 'Departure date',
                    placeholder: 'End (destination departure)',
                },
                number_of_persons: {
                    label: 'Persons',
                    placeholder: 'Number of Persons',
                },
                interval: {
                    choices: {
                        day: 'day',
                        month: 'month',
                        week: 'week',
                        year: 'year',
                    },
                    label: 'Interval',
                },
                is_test_order: {
                    choices: {
                        only_real: 'Real',
                        only_test: 'Test',
                    },
                    label: 'Bookings',
                },
                last_name: 'Lastname',
                payment_status: {
                    choices: {
                        chargedback: 'Charged back',
                        deferred: 'Deferred',
                        failed: 'Failed',
                        in_progress: 'In progress',
                        refunded: 'Refunded',
                        success: 'Success',
                        unknown: 'Unknown',
                    },
                    label: 'Payment status',
                },
                origin_address: {
                    label: 'Pick-up location',
                },
                reservation_status: {
                    choices: {
                        canceled: 'Canceled',
                        completed: 'Completed',
                        error: 'Error',
                        pending: 'Pending',
                        split: 'Split',
                        under_review: 'Under Review',
                    },
                    label: 'Reservation status',
                },
            },
            information: {
                consumer_communication: 'This customer does not automatically receive booking emails.',
                multibookings: {
                    split_from: 'This booking belongs to multi-booking ',
                    split_to: 'This booking has been split to ',
                },
                test_booking: 'This booking is created as a test order.',
            },
            name: 'Bookings',
            paymentSlip: {
                download: {
                    title: 'Download Payment slip',
                },
                send: {
                    description: 'The consumer receives a payment slip for every update, are you sure you would like to send the payment slip manually?',
                    success: 'Payment slip successfully sent',
                    title: 'Send Payment Slip',
                },
                title: 'Payment Slip',
            },
            receipt: {
                administration_fees: 'Administration fees',
                administration_costs: 'Administration costs',
                base_price: 'Base price',
                costfree_cancellation: 'Cost Free Cancellation',
                membership_deduction: 'Membership deduction',
                options: 'Options',
                service_yield: 'Service yield',
                split_deduction: 'Split deduction',
                subtotal_additional: 'Subtotal additional costs',
                subtotal_base: 'Subtotal',
                subtotal_discounts: 'Subtotal discounts',
                total: 'Total',
                transaction_fees: 'Transaction fees',
            },
            retry: {
                description: 'Are you sure you wish to retry this booking?',
                title: 'Retry Booking',
            },
            show: {
                activities: {
                    booking: {
                        empty: 'There are no logged activities for this booking.',
                        label: 'Activities',
                        table: {
                            activity: 'Activity',
                            actor: 'Actor',
                            created_at: 'Date',
                            property: 'Value',
                            status: 'Status',
                            target_id: 'Identifier',
                            target_type: 'Target',
                        },
                    },
                },
                booking_information: 'Booking Information',
                paid_on_invoice: 'This booking is paid on invoice.',
                product: 'Product',
                reseller: 'Reseller',
                reservation: 'Reservation',
                reservation_details: 'Reservation details',
                travel_details: 'Travel details',
            },
            tabs: {
                activities: 'Activities',
                commission: 'Commission',
                customer: 'Customer',
                payment: 'Payment',
                travel: 'Travel',
            },
            voucher: {
                download: {
                    title: 'Download Voucher',
                },
                send: {
                    description: 'The consumer receives a voucher for every update, are you sure you would like to send the voucher manually?',
                    success: 'Voucher successfully sent',
                    title: 'Send Voucher',
                },
                after_alteration: {
                    description: 'Do you want to notify the customer about the updates?',
                },
                title: 'Voucher',
            },
        },
        discount_codes: {
            actions: {
                create: 'Create a discount code',
                edit: 'Edit discount code: %{title}',
            },
            components: {
                expiry_date: {
                    placeholder: 'Expiry Date',
                },
                status: {
                    choices: {
                        unused: 'Unused',
                        used: 'Used',
                    },
                },
                type: {
                    choices: {
                        multi: 'Multi use',
                        single: 'Single use',
                        wallet: 'Wallet',
                    },
                },
                enabled: {
                    choices: {
                        active: 'Active',
                        inactive: 'Inactive',
                    },
                },
            },
            fields: {
                amount: 'Amount',
                amount_used: 'Amount Used',
                currency: 'Currency',
                expiry_date: 'Expiry Date',
                id: 'ID',
                is_enabled: 'Active',
                last_used_at: 'Last used at',
                percentage: 'Percentage',
                status: 'Status',
                token: 'Token',
                type: 'Type',
            },
            title: 'Discount codes',
        },
        discounts: {
            actions: {
                activate: 'Activate',
                create: 'Create a discount',
                deactivate: 'Deactivate',
                edit: 'Edit discount: %{title}',
                list: 'List',
            },
            activity: {
                activate: {
                    title: 'Activate',
                    description: 'Are you sure you want to activate this discount?',
                },
                deactivate: {
                    title: 'Deactivate',
                    description: 'Are you sure you want to deactivate this discount?',
                },
            },
            fields: {
                accountId: 'Account',
                apply_on_fees: 'Apply on fees',
                amount: 'Amount',
                created_at: 'Created at',
                currency: 'Currency',
                end_processing: 'End processing',
                expiry_date: 'Expiry Date',
                id: 'ID',
                is_enabled: 'Active',
                limit: 'Limit',
                percentage: 'Percentage',
                priority: 'Priority',
                title: 'Title',
                uses_discount_codes: 'Uses discount codes',
            },
            forms: {
                account: 'Account',
                discount_codes: 'Discount codes',
                general: 'General',
                manage_discount_codes: 'Discount codes',
            },
            operators: {
                labels: {
                    and: 'And',
                    equal_or_greater_than: 'Equal or greater than',
                    equal_or_less_than: 'Equal or less than',
                    equal: 'Is equal',
                    greater_than: 'Greater than',
                    less_than: 'Less than',
                    not_equal: 'Is not equal to',
                    or: 'Or',
                    within: 'Within',
                },
                title: 'Operator',
            },
            placeholders: {
                email_domain: 'e.g nu.nl',
            },
            rules: {
                appliance: 'Appliance rules',
                condition: 'Conditions rules',
                title: 'Appliance & Conditions Rules',
                no_results: 'There are no %{type}',
            },
            types: {
                global: 'Global',
                regular: 'Regular',
            },
            title: 'Discounts',
        },
        invitations: {
            actions: {
                accept: {
                    title: 'Accept Invitation',
                    description: 'Do you want to accept this invitation?',
                },
                deny: {
                    title: 'Deny Invitation',
                    description: 'Do you want to deny this invitation?',
                },
            },
            no_invitations: 'No invitations found.',
            open_invitations: 'Open invitations',
            request_title: 'Invitation requests',
            sent_title: 'Sent invitations',
            title: 'Invitations',
        },
        invoices: {
            download: 'Download Invoice',
            export: {
                success: 'Invoices have exported successfully.',
                title: 'Export invoices',
                lines: {
                    title: 'Export invoice lines',
                },
            },
            fields: {
                amount: 'Amount',
                invoiced_at: 'Invoiced at',
                status: 'Status',
            },
            show: {
                details: 'Details',
                title: 'Invoice show',
            },
            status: {
                charged_back: 'Charged back',
                open: 'Open',
                overdue: 'Overdue',
                paid: 'Paid',
                paid_manually: 'Paid manually',
                processing: 'Processing',
            },
            title: 'Invoices',
        },
        general: {
            fields: {
                boolean: {
                    yes: 'Yes',
                    no: 'No',
                },
            },
        },
        memberships: {
            actions: {
                edit: 'Edit membership: %{title}',
            },
            fields: {
                concurrency: 'Concurrency',
                purge_reservations: 'Purge reservations',
                paid_by_invoice: 'Paid by invoice',
            },
            messages: {
                created: {
                    success: 'Membership created successfully',
                },
                deleted: {
                    success: 'Membership deleted successfully',
                },
                updated: {
                    success: 'Membership updated successfully',
                },
            },
        },
        membership_schedules: {
            messages: {
                created: {
                    success: 'Membership schedule created successfully',
                },
                deleted: {
                    success: 'Membership schedule deleted successfully',
                },
                updated: {
                    success: 'Membership schedule updated successfully',
                },
            },
        },
        no_account: {
            description: 'In order to use the dashboard, you need to be associated with a partner. One of our partners might have send you an invitation to join their company account. Click the button above to see if there are any open invitations.',
            title: 'No account available',
        },
        password: {
            error: {
                password_current: 'The password does not match with the existing password.',
            },
            name: 'Change your password',
            fields: {
                password_current: 'Current password',
                password_new: 'New password',
                password_confirmation: 'Confirm new password',
            },
            success: 'The password has been saved successfully.',
        },
        points_of_interest: {
            actions: {
                create: 'Create a new Point of Interest',
                edit: 'Edit Point of Interest: %{title}',
                show: 'Point of Interest: %{title}',
            },
            fields: {
                address: 'Address',
                city: 'City',
                country: 'Country',
                google_place_id: 'Google place ID',
                id: 'ID',
                is_highlighted: 'Highlighted',
                latitude: 'Latitude',
                location_x: 'Location x',
                location_y: 'Location y',
                longitude: 'Longitude',
                name: 'Name',
                state: 'State',
                street: 'Street',
                street_number: 'Nº',
                type: 'Type of POI',
                zipcode: 'Zip',
            },
            import: {
                dropzone: {
                    description: 'Drag & drop or press import your CSV file with the new points-of-interests.',
                    title: 'Upload CSV',
                },
                title: 'Import point of interests from CSV',
            },
            promoted_products: {
                add: 'Add a promoted product',
                no_results: 'There are no promoted products',
                title: 'Promoted products',
            },
            title: 'Points of Interest',
            types: {
                accommodation: 'Accommodation',
                airport: 'Airport',
                beach: 'Beach',
                bridge: 'Bridge',
                business_centre: 'Business center',
                city: 'City',
                cultural: 'Cultural',
                education: 'Education',
                event: 'Event',
                event_center: 'Event center',
                government_building: 'Government building',
                hospital: 'Hospital',
                library: 'Library',
                museum: 'Museum',
                neighbourhood: 'Neighbourhood',
                other: 'Other',
                park: 'Park',
                port: 'Port',
                recreation: 'Recreation',
                religious_building: 'Religious building',
                restaurant: 'Restaurant',
                shopping_centre: 'Shopping center',
                sight: 'Sight',
                station: 'Station',
            },
        },
        products: {
            actions: {
                activate: 'Activate',
                create: 'Create product',
                deactivate: 'Deactivate',
                edit: 'Edit product',
                localisation: 'Product Content',
                occupancy: 'Occupancy',
                resource: 'Resource',
            },
            activity: {
                activate: {
                    title: 'The product is activated',
                    description: 'The product is now made visible on all our platforms.',
                },
                deactivate: {
                    title: 'The product is deactivated',
                    description: 'The product is not visible and the end user will no longer see the product.',
                },
            },
            administration_fee: {
                title: 'Administration fee',
            },
            advancedTimes: {
                title: 'Maximum and minimum advanced times',
                fields: {
                    maximum_advance: 'Maximum advanced time',
                    minimum_advance: 'Minimum advanced time',
                },
            },
            allowed_capacity_excess: {
                title: 'Allowed capacity excess',
                fields: {
                    capacity_excess: 'Capacity excess',
                },
            },
            attribute: 'Attribute',
            availability: {
                button: 'Validate',
                dialog: {
                    description: '',
                    title: 'Validate the product',
                },
                results: {
                    arrival_dates_blocked: 'Blocked arrival dates',
                    available_price_information: 'Price Available',
                    blocked_dates: 'Blocked dates',
                    capacity: 'Capacity',
                    configuration: 'Product configuration',
                    consumer_price: 'Consumer price',
                    departure_dates_blocked: 'Blocked departure dates',
                    has_time_zone: 'Correct time zone',
                    is_visible: 'Product is visible',
                    maximum_advance: 'Max. Advance',
                    maximum_duration: 'Max. Duration',
                    minimum_advance: 'Min. Advance',
                    minimum_duration: 'Min. Duration',
                    operational_times: 'Operational times',
                    pricing_service_price: 'Pricing service price',
                    product_enabled: 'Product active',
                    provider_enabled: 'Provider active',
                    provider_price: 'Provider price',
                    supported_currency: 'Currency supported',
                    supported_resource: 'Resource settings correct',
                    valid_price: 'Price valid',
                },
            },
            arrival_dates_blocked: {
                title: 'Blocked Arrival',
                add: 'Add blocked arrival',
                no_result: 'No blocked arrival dates were found',
            },
            blocked_dates: {
                title: 'Blocked dates',
                add: 'Add blocked date',
                no_result: 'No blocked dates were found',
            },
            capacity: {
                title: 'Capacity',
            },
            configuration: {
                saved: 'The product configuration was saved successfully.',
            },
            count: 'Count',
            departure_dates_blocked: {
                title: 'Blocked departure dates',
                add: 'Add blocked dates',
                no_result: 'No blocked departure dates were found',
            },
            duration: {
                no_duration: 'No maximum or minimun duration found for this product.',
                fields: {
                    maximum_duration: 'Maximum duration',
                    minimum_duration: 'Minimum duration',
                },
                placeholders: {
                    duration: 'e.g 10d or 12h',
                    duration_day: 'e.g 10d',
                    duration_hour: 'e.g 12h',
                },
            },
            edit: {
                location: 'Edit Location',
                resource: 'Edit Resource',
            },
            entries: {
                no_result: 'No schedule found',
                add: 'Add new schedule',
            },
            fields: {
                active: 'Active',
                administration_fee: {
                    maximum: 'Maximum',
                    maximum_placeholder: 'e.g. 1.99, 2.50',
                    minimum: 'Minimum',
                    minimum_placeholder: 'e.g. 1.99, 2.50',
                    percentage: 'Percentage',
                    percentage_placeholder: 'e.g. 0.10 (10%), 0.03 (3%)',
                },
                allow_overstay: 'Allow overstay',
                category_id: 'Category',
                city: 'City',
                communicate_email_addresses: 'Communicate email addresses',
                country: 'Country',
                company_id: 'Provider',
                configuration: 'Configuration',
                conditionz: 'Terms & Conditions',
                country_code: 'Country code',
                date: 'Date',
                description: 'Dutch description',
                description_de: 'German description',
                description_en: 'English description',
                description_es: 'Spanish description',
                description_fr: 'French description',
                description_it: 'Italian description',
                duration: 'Maximum and minimum duration',
                email1: 'Email address provider',
                email2: 'Email address admin',
                email_domain: 'Email domain',
                email_from: 'Send email from',
                enabled: 'Active',
                from: 'From',
                freeze_period: 'Freeze Period',
                icon: 'Icon',
                id: 'Id',
                inactive: 'Inactive',
                internal_qr_code: 'Internal QR code',
                is_combined: 'Combined',
                is_official_facility: 'This is an official facility',
                is_visible: 'Visible',
                key: 'Key',
                leeway: 'Arrival and departure leeway',
                location_address: 'Adres',
                location_id: 'Location Id',
                location_latitude: 'Latitude',
                location_longitude: 'Longitude',
                logo: 'Logo',
                mail: 'Email written in Dutch',
                mail_de: 'Email written in German',
                mail_en: 'Email written in English',
                mail_fr: 'Email written in French',
                map_image: 'Location image',
                number_of_persons: 'Number of persons',
                operational_times: 'Operating times',
                options: 'Options',
                parking_id: 'Parking Id',
                phone: 'Phonenumber',
                point_of_interest_id: 'Point of interest',
                priority: 'Priority',
                product_id: 'Provider',
                property_id: 'Property',
                provider_id: 'Provider',
                radius: 'Radius',
                rating: 'Rating',
                resource: {
                    id: 'Resource Id',
                    name: 'Resource Name',
                },
                service_id: 'Service',
                split_percentage: 'Split Price percentage',
                street: 'Street',
                subcategory_id: 'Subcategory',
                terms_and_conditions: {
                    title: 'Terms and conditions',
                    link: 'Url',
                    link_placeholder: 'Enter url',
                    name: 'Name',
                    name_placeholder: 'Enter name',
                },
                to: 'To',
                title: 'Title',
                type: 'Type',
                updated_at: 'Updated',
                value: 'Value',
                vat_percentage: 'VAT percentage',
                voucher_include_invoice: 'Voucher include invoice',
                weekday: 'Weekday',
                zipcode: 'Zipcode',
            },
            filters: {
                radius: {
                    '5': '5km',
                    '10': '10km',
                    '15': '15km',
                    '20': '20km',
                    '25': '25km',
                },
            },
            forms: {
                access_methods: 'Access methods',
                content: 'Content',
                general: 'General',
                location: 'Location',
                logo: 'Logo',
                preferences: 'Preferences',
                properties: 'Properties',
                provider: 'Provider',
                related: 'Related',
            },
            freeze_period: {
                placeholder: 'e.g 2h',
            },
            leeway: {
                fields: {
                    leeway_arrival: 'Arrival leeway',
                    leeway_departure: 'Departure leeway',
                },
                placeholders: {
                    leeway: 'e.g 30 (min)',
                },
            },
            name: 'product',
            notifications: {
                configuration: 'This product is missing configurations. Go on the configuration page to adjust the product-configuration.',
                inactive: 'This product is inactive. Click the activation button to activate the product.',
                product_missing_data: 'This product is missing configuration and/or resource-data. Please provide the data then retry activating the product.',
                'product-missing-data-for-enable': 'This product is missing configuration and/or resource-data.',
                resource: 'This product is missing resource. Go on the resource page to adjust the product-resource.',
                vat_percentage: 'This product is missing an applied VAT percentage in the product-configurations. Go on the configuration page to adjust the VAT percentage.',
            },
            number_of_persons: {
                placeholder: 'Maximum number of persons',
            },
            operational_times: {
                add: 'Add operating time',
                no_result: 'There are no operating times in this product.',
                save: 'Save operating times',
                title: 'Operating times',
            },
            occupancy: {
                graph: {
                    label: {
                        capacity: 'Capacity',
                        hour: {
                            capacity: 'Per hour capacity',
                            occupancy: 'Per hour occupancy',
                        },
                        occupancy: 'Occupancy',
                    },
                    no_results: 'No products are booked on the selected date.',
                    title: 'Occupancy',
                },
                reservations: {
                    destination_arrival_date: {
                        no_results: 'No arriving reservations were found for the selected date.',
                        title: 'Arriving reservations (%{count})',
                    },
                    destination_departure_date: {
                        no_results: 'No departing reservations were found for the selected date.',
                        title: 'Departing reservations (%{count})',
                    },
                    id: {
                        no_results: 'No other reservations were found for around the selected date.',
                        title: 'Other reservations (%{count})',
                    },
                },
            },
            title: 'Products',
            properties: {
                no_results: 'There are no properties added to this product.',
            },
            related: {
                add: 'Add a related product',
                delete: {
                    description: 'The item will be removed permanently. This action cannot be undone.',
                    title: 'Are you sure you wish to delete this?',
                },
                no_results: 'There are no related products',
                title: 'Related',
            },
            require_one_of: {
                add: 'Add a required related product',
                no_result: 'There are no required related products',
                title: 'Require one of',
            },
            rules: 'Rules',
            sales_price: {
                add: 'Add a sales price property',
                no_result: 'There are no sales price configurations',
                title: 'Sales price',
            },
            pages: {
                location: 'Edit the location: %{title}',
                resource: 'Edit the Resource: %{title}',
            },
            value: {
                add: 'Add a %{type}',
                label: 'Value',
                no_result: 'There are no %{type} in this configuration.',
                save: 'Save %{type}',
                title: 'Value',
                types: {
                    dates: {
                        plural: 'dates',
                        singular: 'date',
                    },
                    email_domain: {
                        plural: 'email domains',
                        singular: 'email domain',
                    },
                    time: {
                        plural: 'times',
                        singular: 'time',
                    },
                },
            },
            communicate_email_addresses: {
                placeholder: 'Choose whether to communicate email addresses',
                choices: {
                    do_not_send: 'Do not send',
                    send: 'Send',
                    send_masked: 'Send masked',
                },
            },
            voucher_include_invoice: {
                placeholder: 'e.g. yes or no',
            },
        },
        product_memberships: {
            actions: {
                create: 'Create a product membership',
                edit: 'Edit the product membership',
            },
            create: {
                pricing: 'We will use the default price of the product membership if you don\'t update the price field',
            },
            fields: {
                group_identifier: 'Group identifier',
                membership_schedule: 'Schedule',
                price_ondemand: 'Price on-demand',
                price_scheduled: 'Price scheduled',
                product_membership_id: 'Product membership',
                supports_ondemand: 'Supports on-demand',
                supports_scheduled: 'Supports scheduled',
                user_product_membership_pool_id: 'Product membership pool',
                user_vehicle_id: 'Vehicle',
                deferred: 'Deferred',
                payment_method_description: 'By default the payment method is set to Invoice. If you want to use deferred payment, please check the box below.',
            },
            no_results: 'There are no product memberships',
            title: 'Product memberships',
        },
        profile: {
            name: 'Profile',
        },
        properties: {
            actions: {
                create: 'Create a property',
                edit: 'Edit the property',
                show: 'Property: %{title}',
            },
            fields: {
                icon: 'Icon',
                name: 'Name',
                priority: 'Priority',
                property_group_id: 'Property group',
            },
            languages: {
                label: 'Select an available language',
            },
            title: 'Properties',
            validate: {
                property_group_id: 'Fill in a property group',
                'property-groups-not-available': 'Property group is not available.',
            },
        },
        propertygroups: {
            actions: {
                create: 'Create a property group',
                edit: 'Edit the property group: %{title}',
                show: 'Property group: %{title}',
            },
            fields: {
                id: 'ID',
                name: 'Name',
                properties: 'Properties',
                property: 'Property',
            },
            languages: {
                label: 'Select an available language',
            },
            name: 'Property group',
            plural: 'Property groups',
        },
        reservations: {
            fields: {
                booking_order_id: 'Client Mobian ID',
                cancelled_at: 'Cancelled at',
                created_at: 'Created',
                customer: 'Customer',
                customer_remarks: 'Customer Remarks',
                destination_address: 'Drop-off location',
                destination_arrival_date: 'Arrival date',
                destination_departure_date: 'Departure date',
                drop_off_date: 'Drop-Off Date',
                ending_at: 'Ending at',
                flight_number: 'Flight number',
                full_name: 'Name',
                internal_order_id: 'Order ID',
                last_name: 'Last name',
                license_plate: 'License plate',
                number_of_persons: 'Number of persons',
                origin_address: 'Pick-up location',
                phone: 'Phone',
                pick_up_date: 'Pick-up date',
                product: 'Product',
                remote_reference: 'Remote reference',
                return_flight_number: 'Return flight number',
                starting_at: 'Starting at',
                subscription_id: 'Subscription ID',
                subscription_reservation_id: 'Subscription reservation ID',
                updated_at: 'Last updated',
            },
            name: 'Reservation',
            open_barrier: {
                description: 'Do you want to open the barrier for the current reservation?',
                modal: {
                    error: 'Oops, something went wrong while opening the barrier. Please try again later',
                    force_not_allowed_for_access_method: 'The barrier is not allowed for this access method.',
                    session_open_barrier_requires_access_point: 'The session open barrier requires an access point.',
                    success: 'The barrier was successfully opened.',
                },
                title: 'Open the barrier',
            },
            title: 'Reservations',
            session: {
                asset_not_usable: {
                    description: 'You can retry with force stop, this will always end the session and put the asset back to `available` if the session was started with one',
                    title: 'Session stop failed due to following prerequisites:',
                },
                button: {
                    end: 'Stop the session',
                    start: 'Start the session',
                    open_barrier: 'Open the barrier',
                },
                modal: {
                    button: {
                        submit: {
                            end: 'Stop the session',
                            start: 'Start the session',
                        },
                    },
                    callback: {
                        end: {
                            error: 'Oops, something went wrong while ending the session. Please try again later',
                            success: 'The session was successfully ended.',
                        },
                        start: {
                            error: 'Oops, something went wrong while starting the session. Please try again later',
                            success: 'The session was successfully started.',
                        },
                    },
                    checkbox: 'Open the gate',
                    force: 'Force session stop',
                    description: {
                        end: 'The current reservation session has already started. Click the checkbox if you want to open or close the gate.',
                        start: 'The current reservation session has not started yet. Click the checkbox if you want to open or close the gate.',
                    },
                    title: {
                        end: 'Stop the session',
                        start: 'Start the session',
                    },
                },
            },
            show: {
                activities: {
                    access_sessions: {
                        title: 'Access sessions',
                        not_found: 'No access session activities were found for this reservation',
                        started_at: 'Started at',
                        ended_at: 'Ended at',
                        status: 'Status',
                    },
                },
                booking_information: 'Booking information',
                product: 'Product',
                reservation_details: 'Reservation details',
                reservation_price: 'Reservation price',
                travel_details: 'Travel details',
            },
        },
        subcategories: {
            actions: {
                create: 'Create a subcategory',
                edit: 'Edit the subcategory',
                show: 'Subcategory: %{title}',
            },
            fields: {
                id: 'ID',
                name: 'name',
                category_id: 'category',
            },
            languages: {
                label: 'Select an available language',
            },
            title: 'Subcategories',
            validate: {
                'categories-not-available': 'There are no categories available.',
            },
        },
        subscriptions: {
            actions: {
                create: 'Create',
                edit: 'Edit',
            },
            fields: {
                account: 'Account',
                company_name: 'Company name',
                currency: 'Currency',
                email: 'Email',
                end_date: 'End date',
                first_name: 'First name',
                full_name: 'Fullname',
                last_name: 'Last name',
                language: 'Language',
                license_plate: 'License plate',
                name: 'Name',
                order_id: 'Order ID',
                phone: 'Phone',
                price: 'Price',
                start_date: 'Start date',
                status: 'Status',
                terminated_at: 'Terminated at',
            },
            show: {
                subscription_details: 'Subscription details',
                subscription: 'Subscription',
            },
            tooltips: {
                ok: 'Ok',
                pending: 'Subscription: pending',
                under_review: 'Subscription: under review',
            },
            title: 'Subscriptions',
        },
        subscriptionProducts: {
            fields: {
                end_time: 'End time',
                start_time: 'Start time',
                day: 'Day',
                product: 'Product',
            },
            input: {
                day: {
                    1: 'Monday',
                    2: 'Tuesday',
                    3: 'Wednesday',
                    4: 'Thursday',
                    5: 'Friday',
                    6: 'Saturday',
                    7: 'Sunday',
                },
            },
            create: {
                title: 'Add subscription product',
            },
            no_results: 'No subscription products were found.',
            title: 'Subscription products',
        },
        users: {
            actions: {
                activate: 'Activate',
                create: 'Create user',
                deactivate: 'Deactivate',
                edit: 'Edit user',
                reset_password: 'Reset Password',
            },
            activity: {
                activate: {
                    title: 'The user will be activated',
                    description: 'When the user is active, the user can log in to our dashboards, apps and use our services.',
                },
                deactivate: {
                    title: 'The user will be deactivated',
                    description: 'When the user is inactive, the user can no longer log in to our dashboards, apps or use our services.',
                },
            },
            delete: {
                warnings: {
                    'user-has-active-memberships': 'Active memberships exist for this user.',
                    'user-has-active-subscriptions': 'Active subscriptions exist for this user.',
                    'user-has-future-bookings': 'Future bookings still exist for this user.',
                    'user-has-invoicable-bookings': 'Invoicable bookings exist for this user.',
                    'user-has-open-invoices': 'Open invoices exist for this user.',
                    'user-has-overdue-invoices': 'Overdue invoices exist for this user.',
                    'user-has-recent-recurring-payment-activity': 'Recent recurring payment activity exists for this user.',
                    'user-has-wallet-funds': 'Wallet funds applicable for this user.',
                },
            },
            fields: {
                active: 'Active',
                address: 'Address',
                bic: 'BIC',
                city: 'City',
                company_email: 'Company Email',
                company_name: 'Company Name',
                company_registration: 'COC Number',
                company_vat: 'VAT number',
                contract: 'Contract',
                country: 'Country',
                email: 'Email',
                external_yield: 'External Yield',
                firstname: 'Firstname',
                iban: 'IBAN',
                lastname: 'Lastname',
                locale: 'Locale',
                logo: 'Logo',
                membership_id: 'Membership',
                name: 'Name',
                orders: 'Orders',
                phonenumber: 'Phone',
                product_commission_reseller: 'Reseller Product commission',
                provider_id: 'Provider',
                reseller_id: 'Reseller',
                role: 'Role',
                title: 'Title',
                url: 'URL',
                user_id: 'Reseller',
                username: 'Username',
                vat: 'VAT',
                yield_commission: 'Yield Commission',
                zipcode: 'Zipcode',
            },
            filters: {
                active: {
                    active: 'Only active',
                    inactive: 'Only inactive',
                },
            },
            forms: {
                account: 'Account',
                address: 'Address',
                company: 'Company',
                contact: 'Contact',
                general: 'General',
                products: 'Last Updated Products',
                registrations: 'Registrations',
            },
            memberships: {
                create: 'User membership create',
                edit: 'User membership edit (%{name})',
                no_results: 'There are no memberships linked with this user',
                pricing: 'Pricing',
            },
            name: 'User',
            no_results: 'No users were found.',
            not_found: 'No user was found.',
            notifications: {
                inactive: 'This user is inactive. Click on the activate button to activate the user.',
                not_confirmed: 'This user has not yet confirmed their account.',
            },
            products: {
                actions: {
                    list: 'Show all Products (%{total})',
                },
            },
            // User-product-memberships create and edit
            product_memberships: {
                actions: {
                    create: 'Create a user-product-membership',
                    edit: 'Edit user-product-membership',
                },
            },
            title: 'Users',
            reset_password: {
                description: 'Resetting a password will send a new password towards the user’s email. The old password will no longer be useable. Currently logged in sessions of this user will require them to login on all devices with their new password.',
                title: 'Reset the users password',
            },
            roles: {
                reseller: 'Reseller',
                provider: 'Provider',
            },
        },
        wallets: {
            fields: {
                amount: 'Amount',
                balance: 'Balance',
                reason: 'Reason',
                type: 'Type',
            },
            no_results: 'No wallets were found',
            title: 'Wallets',
            topup: {
                notifications: {
                    success: {
                        decrease: 'User wallet has been successfully decreased.',
                        increase: 'User wallet has been successfully increased.',
                    },
                },
                label: 'Top-up',
                title: 'Wallet top-up',
            },
        },
        webhooks: {
            actions: {
                create: 'Create a Webhook',
                edit: 'Edit Webhook: %{title}',
            },
            fields: {
                action_booking_cancelled: 'Action Booking Cancelled',
                action_booking_created: 'Action Booking Created',
                action_booking_initialised: 'Action Booking Initialised',
                action_booking_modified: 'Action Booking Modified',
                action_booking_under_review: 'Action Booking Under Review',
                action_reservation_cancelled: 'Action Reservation Cancelled',
                action_reservation_created: 'Action Reservation Created',
                action_reservation_modified: 'Action Reservation Modified',
                is_active: 'Active',
                name: 'Name',
                url: 'Url',
            },
            forms: {
                actions: 'Actions',
                general: 'General',
            },
            title: 'Webhooks',
        },
    },
    page: {
        page_not_found: {
            title: 'Page not found',
            description: 'The page you are looking for can not be found.',
        },
        resource_not_found: {
            description: 'We could not find the resource you are looking for. Please try return to the page.',
            title: 'Resource not found',
        },
        not_authorised: {
            title: 'Oops..',
            description: 'It looks like you are not authorised to see this page.',
        },
    },
    release: {
        list: {
            description: 'In this release we updated the visuals for the lists pages. We removed the show button and made it possible to hover and click on the row to be redicted to the detail page for that specific item.',
            title: 'Small update to our overview pages',
        },
    },
    signUp: {
        errors: {
            passowrd_chars: 'Password must contain at least 6 characters',
            same_email: 'Emails must be equal',
            same_password: 'Passwords must be equal',
        },
        fields: {
            confirm_email: 'Confirm email',
            confirm_password: 'Confirm password',
        },
        no_account: 'I don’t have an account',
        title: 'Register',
        success: 'User has been registered successfully',
    },
};



// WEBPACK FOOTER //
// ./src/i18n/en.js